// extracted by mini-css-extract-plugin
export default {"overlay":"transparent-overlay_overlay__cHmv9"};